import React, { FC } from 'react';
import { Lights, CanvasBackground, Dialog } from '../../../../components';
import { NUM_STAGES, STAGES } from '../../../../traits';
import { useCamera } from '../../../../utils';

export type WinProps = {};
export const Win: FC<WinProps> = () => {
  useCamera([0, -70, 0], [0, 0, 0], 60);
  const background = STAGES[NUM_STAGES].background;

  return (
    <group>
      <Lights />
      <CanvasBackground texture={background} />
      <Dialog
        text="MADE IT"
        position={[0, -25, 0]}
        size={[180, 30]}
        canvasSize={[120, 20]}
        center
        color={background.dark ? [255, 255, 255, 255] : [0, 0, 0, 255]}
      />
    </group>
  );
};
